import React, { createContext, useContext, useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import useGetSocketURL from '../hooks/socket/useGetSocketURL'
import useMaintainSocketConnection from '../hooks/socket/useMaintainSocketConnection'

const SocketContext = createContext()

export const useSocket = () => {
  const context = useContext(SocketContext)

  if (!context) {
    throw new Error('Socket context is not found!')
  }

  return context
}

const SocketProvider = ({ children, isLoggedIn, token }) => {
  const { socketData, addAuthToURL } = useGetSocketURL(token, {
    enabled: isLoggedIn,
  })

  const [socketURL, setSocketURL] = useState(null)
  const { socket } = useMaintainSocketConnection({ socketURL })

  useEffect(() => {
    if (!isLoggedIn || !socketData) return setSocketURL(null)

    const { uri: url } = socketData
    if (typeof url !== 'string') return
    setSocketURL(addAuthToURL(url))
  }, [socketData])

  const values = {
    socket,
  }

  return (
    <SocketContext.Provider value={values}>{children}</SocketContext.Provider>
  )
}

SocketProvider.propTypes = {
  children: PropTypes.any,
  isLoggedIn: PropTypes.bool,
  token: PropTypes.string,
}

export default SocketProvider
